import "./header.scss";

import { compose } from "@wordpress/compose";
import { withDispatch, withSelect } from "@wordpress/data";
import React from "react";
import { SearchBox } from "react-instantsearch-dom";
import CurrentRefinements from "../components/CurrentRefinements";
import ClearRefinements from "../components/ClearRefinements";
import BulkEditBar from "../containers/BulkEditBar";
import MyPlaylists from "./MyPlaylists";

function header({ playlistsModalOpen, setPlaylistsModalOpen }) {
  return (
    <div className="headerWrap pagewrap">
      <div className="header flexcont">
        <a href="http://www.hifiproject.com/" className="logo">
          <img
            src="/wp-content/uploads/2016/03/hifi-logo-white.png"
            width="200"
            height="100"
            alt="Hifi Shop Logo"
          />
        </a>
        <div className="middle flexauto">
          <BulkEditBar />
          <div className="flexcont">
            <div className="search flexauto">
              <SearchBox
                autoFocus
                translations={{
                  placeholder:
                    "Search by title, artist, genre, instrument, keyword..",
                }}
              />
            </div>
            <div className="refinements">
              <CurrentRefinements />
            </div>
            <div className="clear-refinements">
              <ClearRefinements />
            </div>
            <MyPlaylists />
          </div>
        </div>
      </div>
    </div>
  );
}
const Header = compose(
  withSelect((select) => {
    const { getPlaylistsModalOpen } = select("hifi");

    return {
      playlistsModalOpen: getPlaylistsModalOpen(),
    };
  }),
  withDispatch((dispatch) => {
    const { setPlaylistsModalOpen } = dispatch("hifi");

    return {
      setPlaylistsModalOpen,
    };
  })
)(header);

export default Header;
